// Marcos normativos de referencia sugeridos por aspecto, a modo orientativo
// para la sección "Relevante" del formulario SMART de objetivos ambientales.
export const frameworksByAspect = {
  energy: ["Higg FEM", "GRI 302", "GHG Protocol", "ISO 50001"],
  fuels: ["Higg FEM", "GRI 305", "GHG Protocol — Alcance 1"],
  water: ["Higg FEM", "GRI 303", "ISO 14046"],
  effluent: ["Higg FEM", "GRI 303-4", "ZDHC"],
  waste: ["Higg FEM", "GRI 306"],
};
